exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".egrul-records-table[data-v-11608fd2] {\n  font-size: 13px;\n}\n.egrul-records-table td[data-v-11608fd2], .egrul-records-table th[data-v-11608fd2] {\n    padding: 8px;\n    vertical-align: top;\n    text-align: left;\n}\n.egrul-records-table th[data-v-11608fd2] {\n    font-weight: 700;\n}\n", ""]);

// exports
